// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__9Q_Jl","footer":"ReportModalFilter_footer__lsczY"};